module.exports = __webpack_public_path__ + "img/Starstruck.df4b510e.png";